import PropTypes from "prop-types"
import React, { useMemo } from "react"

import moment from "moment"
import WeekGrid from "./WeekGrid"
import DayGrid from "./DayGrid"
import { DEFAULT_END_HOUR, DEFAULT_START_HOUR } from "pagesV2/pro/Calendar/constants"

const CalendarTimeGrid = ({ date, events = [], type, journalNoteDates = [], onJournalClick, canCreateJournal = true, canEditJournal = true, canViewJournal = true }) => {
  const hours = Array.from({ length: DEFAULT_END_HOUR - DEFAULT_START_HOUR + 1 }, (_, i) => DEFAULT_START_HOUR + i)
  const weekStartDate = useMemo(() => moment(date).startOf("week"), [date])
  const weekEndDate = useMemo(() => moment(date).endOf("week"), [date])

  const calendarDaysCount = useMemo(() => weekEndDate.diff(weekStartDate, "days") + 1, [weekStartDate, weekEndDate])
  const calendarDays = useMemo(
    () => new Array(calendarDaysCount).fill().map((_, index) => weekStartDate.clone().add(index, "days")),
    [weekStartDate, calendarDaysCount]
  )

  if (type === "week") {
    return <WeekGrid calendarDays={calendarDays} hours={hours} events={events} journalNoteDates={journalNoteDates} onJournalClick={onJournalClick} canCreateJournal={canCreateJournal} canEditJournal={canEditJournal} canViewJournal={canViewJournal} />
  }

  return <DayGrid date={date} calendarDays={calendarDays} hours={hours} events={events} journalNoteDates={journalNoteDates} onJournalClick={onJournalClick} canCreateJournal={canCreateJournal} canEditJournal={canEditJournal} canViewJournal={canViewJournal} />
}

CalendarTimeGrid.propTypes = {
  type: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      start: PropTypes.number,
      end: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string
    })
  ),
  journalNoteDates: PropTypes.array,
  onJournalClick: PropTypes.func,
  canCreateJournal: PropTypes.bool,
  canEditJournal: PropTypes.bool,
  canViewJournal: PropTypes.bool
}

export default CalendarTimeGrid
